module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0008.38f8e843.jpg";